var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:{
    'player-details__anchor': true,
    'player-details__anchor--active': _vm.renderAnchorActiveClassName
  },style:({ color: _vm.color }),attrs:{"href":_vm.anchor}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }